import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function FaqSection() {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'What exactly is included in the 200€ package?',
    answer: "The Standard package includes a complete multi-page website design, mobile responsiveness, basic SEO setup, contact forms, social media integration, and hosting setup. It's a turnkey solution to get your business online professionally."
  }, {
    question: 'How long does it take to complete?',
    answer: 'We pride ourselves on speed. The typical turnaround time is 48 hours from the moment we receive your content and requirements. Complex requests might take slightly longer.'
  }, {
    question: 'Do I need to provide the text and images?',
    answer: "Yes, you provide the core content. However, our AI tools can help refine your copy and we can provide high-quality stock imagery if you don't have your own photos."
  }, {
    question: 'Is there a monthly fee?',
    answer: 'The 200€ is a one-time design fee. You will need to pay for your domain and hosting separately (usually around 10-15€/month), but we help you set that up with the best providers.'
  }, {
    question: 'Can I edit the website myself later?',
    answer: 'Absolutely. We build on user-friendly platforms that allow you to make text and image updates easily without needing to know how to code.'
  }, {
    question: "What if I don't like the design?",
    answer: "We offer up to 3 rounds of revisions to ensure you're completely happy with the result. Our AI-driven process usually hits the mark on the first try, but we're here to perfect it."
  }];
  return <section id="faq" className="py-24 bg-[#080808]" data-id="element-89">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-90">
        <div ref={ref} className={`text-center mb-16 transition-all duration-1000 ${isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-91">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-92">
            Frequently Asked <span className="text-[#c9a84c]" data-id="element-93">Questions</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-94">
          {faqs.map((faq, index) => <FaqItem key={index} faq={faq} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} delay={index * 100} data-id="element-95" />)}
        </div>
      </div>
    </section>;
}
function FaqItem({
  faq,
  isOpen,
  onClick,
  delay
}: {
  faq: any;
  isOpen: boolean;
  onClick: () => void;
  delay: number;
}) {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  return <div ref={ref} style={{
    transitionDelay: `${delay}ms`
  }} className={`border border-white/10 rounded-lg overflow-hidden transition-all duration-500 ${isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'} ${isOpen ? 'border-[#c9a84c]/50 bg-[#0a0a0a]' : 'bg-transparent'}`} data-id="element-96">
      <button onClick={onClick} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-97">
        <span className={`font-medium text-lg ${isOpen ? 'text-[#c9a84c]' : 'text-gray-300'}`} data-id="element-98">
          {faq.question}
        </span>
        {isOpen ? <Minus className="h-5 w-5 text-[#c9a84c]" data-id="element-99" /> : <Plus className="h-5 w-5 text-gray-500" data-id="element-100" />}
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-101">
        <div className="p-6 pt-0 text-gray-400 leading-relaxed" data-id="element-102">
          {faq.answer}
        </div>
      </div>
    </div>;
}